module.exports = __webpack_public_path__ + "img/pic-4.d5025d4d.png";